import { gql } from '@/shared/types/gql';

/** Create-or-update the history-index row for a session (idempotent on sessionId). */
export const AI_CIO_CONVERSATION_UPSERT = gql`
  mutation AiCioConversationUpsert($input: AiCioConversationCreateInput!) {
    aiCioConversationUpsert(input: $input) {
      id
      sessionId
      title
    }
  }
`;

export const AI_CIO_CONVERSATION_RENAME = gql`
  mutation AiCioConversationRename($input: AiCioConversationUpdateInput!) {
    aiCioConversationRename(input: $input) {
      id
      sessionId
      title
    }
  }
`;

export const AI_CIO_CONVERSATION_DELETE = gql`
  mutation AiCioConversationDelete($sessionId: String!) {
    aiCioConversationDelete(sessionId: $sessionId)
  }
`;

/** Deletes every history-index row of the caller, the rows `aiCioConversations` lists. */
export const AI_CIO_CONVERSATIONS_CLEAR = gql`
  mutation AiCioConversationsClear {
    aiCioConversationsClear
  }
`;
